import Link from "next/link";
import { useRouter } from "next/router";
import React, { ReactNode } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { usePlausible } from "next-plausible";
import { v4 as uuidv4 } from "uuid";
import { classNames } from "../../../utils/common";

interface PopularSOPCardProps {
  Type: string;
  check: string;
  Icon: ReactNode;
  Name: string;
  Description: string;
}

function PopularSOPCard({
  Type,
  Icon,
  check,
  Name,
  Description,
}: PopularSOPCardProps) {
  const router = useRouter();
  const { sopId } = router.query;
  const plausible = usePlausible();

  const handleClick = (buttonId: any) => {
    plausible(buttonId);
  };

  const generateHref = () => {
    const baseHref = `/${uuidv4()}`;

    if (Type === "Sop Reviewer") {
      return `${baseHref}/reviewer/?type=${Type}`;
    } else if (Type === "Rejection Letter") {
      return `${baseHref}/rejectionletter/?type=${Type}`;
    } else if (Type === "Canadian Consultant") {
      return `${baseHref}/immigration-chatbot/?type=${Type}`;
    } else {
      return `/sop/new/${uuidv4()}/step-2/?type=${Type}`;
    }
  };

  return (
    <div
      className={classNames(
        Type == check || Type == "Canadian Consultant"
          ? "bg-tootler-primary-900"
          : "bg-tootler-primary-900",
        "rounded-2xl mb-6 shadow-xl max-w-xs"
      )}
    >
      <p className="py-1.5 font-bold text-center text-xs uppercase text-white">
        {Name}
      </p>
      <div className="border-tootler-primary-900 space-y-10 py-10 rounded-2xl bg-white h-full border-2 px-6">
        <div className="text-tootler-primary-900">{Icon}</div>
        <div className="text-tootler-primary-900 lg:text-lg normal-case text-center font-semibold">
          {Type}
        </div>
        <div className="text-tootler-grey-500 lg:text-sm normal-case text-center">
          {Description}
        </div>
        <div className="text-xs text-gray-400"></div>
        <Link
          onClick={() => handleClick(`solution-${Type}`)}
          href={generateHref()}
        >
          <div className="border-tootler-primary-900 hover:bg-tootler-primary-700/10 w-fit mt-9 lg:mt-11 border-2 rounded-full mx-auto p-3 transition duration-300 ease-in-out transform hover:scale-110">
            <ChevronRightIcon
              strokeWidth={2}
              className="text-tootler-primary-900 w-6"
            />
          </div>
        </Link>
      </div>
    </div>
  );
}

export default PopularSOPCard;
